/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'

import { WidgetGuard } from 'features/types'
import { MeasureTypesEmptyGuard, TopicNotSelectedGuard } from '../../../../share/guards'

const WidgetSettingGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicNotSelectedGuard widgetId={widgetId}>
    <MeasureTypesEmptyGuard widgetId={widgetId}>{children}</MeasureTypesEmptyGuard>
  </TopicNotSelectedGuard>
)

export default WidgetSettingGuards
